/**
 * 日本語の文言。キーは ko.ts と完全に一致させる（テストが検査する）。
 * 倉庫の担当者はこちらの言語で使う。
 */
export const ja: Record<string, string> = {
  "app.title": "返品管理システム",

  "nav.dashboard": "対応待ち",
  "nav.cases": "返品一覧",
  "nav.caseNew": "返品受付",
  "nav.scan": "入庫スキャン",
  "nav.orphans": "未登録貨物",
  "nav.shipments": "船積み",
  "nav.itemMasters": "品目マスタ",
  "nav.settings": "アカウント",
  "nav.logout": "ログアウト",
  "nav.group.work": "業務",
  "nav.group.master": "マスタ",
  "nav.group.help": "ヘルプ",
  "nav.manual": "マニュアル",
  "nav.group.account": "アカウント",
  "nav.menu": "メニュー",

  "search.title": "統合検索",
  "search.placeholder": "注文番号・伝票番号・顧客名で検索",
  "search.hint": "注文番号、返送伝票番号、顧客名で探します。",
  "search.empty": "該当する返品はありません。",
  "search.move": "移動",
  "search.open": "開く",
  "search.scope": "返品",

  "notify.title": "通知",
  "notify.empty": "新しい通知はありません。",
  "notify.readAll": "すべて既読",
  "notify.unread": "未読 {count}件",
  "notify.kind.overdue": "受付から{days}日過ぎても入庫されていない件 {count}件",
  "notify.kind.review_requested": "項目の確認依頼 {count}件",
  "notify.kind.qty_mismatch": "検品数量が登録と異なる件 {count}件",
  "notify.kind.doc_to_confirm": "書類確認待ち {count}件",
  "notify.kind.kr_inbound_pending": "韓国入庫待ち {count}件",

  "manual.title": "ユーザーマニュアル",
  "manual.description": "実際の画面のメニュー・ボタン名のまま記載しています。探している機能が見つからないときは検索してください。",
  "manual.toc": "目次",
  "manual.search": "マニュアル検索",
  "manual.searchPlaceholder": "例: 返品受付、インボイス、返送伝票番号",
  "manual.results": "検索結果 {count}件",
  "manual.noResults": "該当する内容がありません。",
  "manual.help": "この画面のヘルプ",
  "manual.prev": "前の文書",
  "manual.next": "次の文書",

  "theme.toDark": "ダークモード",
  "theme.toLight": "ライトモード",
  "nav.account": "アカウント",

  "login.title": "ログイン",
  "login.id": "ログインID",
  "login.password": "パスワード",
  "login.submit": "ログイン",
  "login.submitting": "確認中…",

  "role.admin": "管理者",
  "role.shipper": "荷主",
  "role.warehouse": "倉庫",

  "status.registered": "受付済",
  "status.arrived": "入庫済",
  "status.documented": "書類完了",
  "status.shipped": "出庫",
  "status.returned": "返送完了",
  "status.discarded": "廃棄",
  "status.cancelled": "受付取消",

  "doc.pending": "未記入",
  "doc.filled": "インボイス記入済",
  "doc.review_requested": "項目確認依頼",
  "doc.confirmed": "確認済",

  "shipment.draft": "準備中",
  "shipment.shipped": "出庫",
  "shipment.osaka_arrived": "大阪着",
  "shipment.sailed": "海上輸送中",
  "shipment.delivered": "返送完了",

  "reason.change_of_mind": "自己都合",
  "reason.defect": "不良",
  "reason.wrong_item": "誤配送",
  "reason.damaged": "破損",
  "reason.address_unknown": "住所不明",
  "reason.other": "その他",

  "disposition.return_kr": "韓国返送",
  "disposition.discard": "廃棄",
  "freight.collect": "着払い",
  "freight.prepaid": "元払い",
  "carrier.sagawa": "佐川急便",
  "carrier.yamato": "ヤマト運輸",

  "card.arrived_today": "本日の入庫",
  "card.overdue": "未入庫アラート",
  "card.doc_to_confirm": "書類確認待ち",
  "card.ready_to_ship": "出庫待ち",
  "card.arrival_to_confirm": "入庫確認待ち",
  "card.disposition_missing": "処理方針未定",
  "card.items_missing": "インボイス未記入",
  "card.review_requested": "項目確認依頼",
  "card.kr_inbound_pending": "韓国入庫待ち",
  "card.qty_mismatch": "数量不一致",

  "dashboard.title": "対応が必要な件",
  "dashboard.empty": "対応待ちの件はありません。",
  "dashboard.unit": "件",
  "dashboard.description": "対応が必要な件をまとめています。数字を押すとその一覧に移動します。",
  "dashboard.group.urgent": "至急",
  "dashboard.group.mine": "自分の番",
  "dashboard.group.status": "状況",

  "case.seq": "No.",
  "case.receivedOn": "受付日",
  "case.orderNo": "注文番号",
  "case.trackingNo": "返送伝票番号",
  "case.carrier": "搬入配送業者",
  "case.customerName": "お客様名",
  "case.customerPhone": "連絡先",
  "case.returnReason": "返品理由",
  "case.arrivedOn": "搬入日",
  "case.weight": "重量",
  "case.freight": "着払い/元払い",
  "case.codFee": "着払い料金(JPY)",
  "case.disposition": "処理方針",
  "case.docStatus": "書類作成状況",
  "case.status": "ステータス",
  "case.closedOn": "韓国返送/廃棄日",
  "case.invoiceNo": "インボイス番号",
  "case.note": "備考",
  "case.org": "荷主",
  "case.itemCount": "品目",

  "cases.title": "返品一覧",
  "cases.search": "注文番号・伝票番号・お客様名で検索",
  "cases.filterStatus": "ステータス",
  "cases.filterAll": "すべて",
  "cases.from": "受付日(開始)",
  "cases.to": "受付日(終了)",
  "cases.export": "CSVダウンロード",
  "cases.empty": "条件に合う返品はありません。",
  "cases.total": "全{total}件",
  "cases.range": "全{total}件中 {from}–{to}件",
  "cases.sort": "並べ替え",
  "cases.pageSize": "1ページの件数",
  "cases.perPage": "{count}件ずつ",
  "cases.prev": "前へ",
  "cases.next": "次へ",
  "cases.detail": "詳細",
  "cases.clearFilter": "条件をクリア",
  "cases.period": "期間",
  "cases.periodToday": "今日",
  "cases.period7d": "7日",
  "cases.period30d": "30日",
  "cases.periodCustom": "指定",
  "cases.clearAll": "条件をすべて消す",

  "columns.title": "列の設定",
  "columns.reset": "既定の列に戻す",

  "views.title": "保存したビュー",
  "views.save": "今の条件を保存",
  "views.nameLabel": "ビュー名",
  "views.remove": "ビューを削除",
  "cases.emptyHint": "検索語や期間を変えてみてください。",

  "caseNew.title": "返品受付",
  "caseNew.submit": "受付を登録",
  "caseNew.trackingHint": "まだ不明な場合は空欄のままにします。",
  "caseNew.orgPlaceholder": "荷主を選択してください",
  "caseNew.carrierPlaceholder": "配送業者を選択してください",
  "caseNew.done": "受け付けました。",

  "caseDetail.title": "返品詳細",
  "caseDetail.intake": "受付情報",
  "caseDetail.arrival": "入庫情報",
  "caseDetail.handling": "処理・確認",
  "caseDetail.items": "インボイス品目",
  "caseDetail.shipment": "船積み",
  "caseDetail.history": "履歴",
  "caseDetail.edit": "編集",
  "caseDetail.save": "保存",
  "caseDetail.cancelEdit": "キャンセル",
  "caseDetail.cancelCase": "受付を取消",
  "caseDetail.confirmArrival": "入庫内容を確認",
  "caseDetail.arriveManually": "手入力で入庫",
  "caseDetail.inspect": "検品結果を保存",
  "caseDetail.inspectedAt": "検品",
  "caseDetail.inspectNote": "検品メモ",
  "caseDetail.setDisposition": "処理方針を決める",
  "caseDetail.requestReview": "項目の確認を依頼",
  "caseDetail.confirmDoc": "書類を確定",
  "caseDetail.invoice": "インボイスをダウンロード",
  "caseDetail.discard": "廃棄処理",
  "caseDetail.noShipment": "まだ船積みされていません。",
  "caseDetail.reviewReason": "日本側の確認が必要な理由",
  "caseDetail.closedOn": "処理日",
  "caseDetail.tab.summary": "概要",
  "caseDetail.tab.items": "インボイス品目",
  "caseDetail.tab.history": "履歴",
  "caseDetail.nextActions": "次の作業",
  "caseDetail.nextActionsEmpty": "この件で今できる作業はありません。",
  "caseDetail.owner.shipper": "荷主の作業",
  "caseDetail.owner.warehouse": "日本側の作業",
  // 担当ラベル — 「作業」ではない場所(要約カード・履歴)で使う短い名前(lib/case-owner.ts)。
  "owner.shipper": "荷主",
  "owner.warehouse": "クールトラックJP",
  "owner.side.shipper": "韓国・荷主",
  "owner.side.warehouse": "日本・倉庫",
  "caseDetail.blockedReason": "実行できない理由",
  "caseDetail.terminal": "この件は終了しました。",
  "caseDetail.historyEmpty": "まだ履歴がありません。",
  "caseDetail.step.registered": "受付",
  "caseDetail.step.arrived": "入庫",
  "caseDetail.step.documented": "書類",
  "caseDetail.step.shipped": "出庫",
  "caseDetail.step.returned": "完了",

  "lines.title": "返品商品",
  "lines.hint": "何が何点戻るのかを記入します。日本側が開梱してこの数量と突き合わせます。",
  "lines.item": "商品",
  "lines.manual": "直接入力",
  "lines.description": "商品名",
  "lines.descriptionHint": "一覧にない場合はここに記入します。",
  "lines.qty": "返品数量",
  "lines.receivedQty": "検品数量",
  "lines.add": "行を追加",
  "lines.remove": "行を削除",
  "lines.empty": "登録された返品商品はありません(旧データ)。",

  "items.add": "品目を追加",
  "items.remove": "削除",
  "items.search": "品名・HSコードで検索",
  "items.qty": "数量",
  "items.unitPrice": "単価",
  "items.amount": "金額",
  "items.description": "品名(英語)",
  "items.hsCode": "HSコード",
  "items.origin": "原産地",
  "items.total": "合計",
  "items.save": "品目を保存",
  "items.empty": "記入された品目はありません。",
  "items.pickMaster": "品目マスタから選ぶ",
  "items.manual": "直接入力",
  "items.count": "{count}点",
  "items.masterResults": "検索結果",

  "scan.title": "入庫スキャン",
  "scan.prompt": "伝票のバーコードをスキャンしてください",
  "scan.input": "伝票番号",
  "scan.success": "入庫しました",
  "scan.weightPrompt": "重量を入力してください (g)",
  "scan.saveWeight": "重量を保存",
  "scan.save": "保存",
  "scan.codFeeHint": "わからなければ空欄のままにします。",
  "scan.skipWeight": "あとで",
  "scan.today": "本日のスキャン",
  "scan.orphanTitle": "未登録貨物",
  "scan.orphanDesc": "受付がないまま倉庫に届いた荷物です。佐川・ヤマトの送り状のみ記録します。",
  "scan.orphanNew": "受付が見つからないため未登録貨物として記録しました — {trackingNo}",
  "scan.orphanAgain": "すでに未登録貨物として記録されています — {trackingNo}",
  "scan.orphanCount": "{count}回スキャン",
  "orphan.linkTitle": "無敵貨物を受付案件に紐づける",
  "orphan.linkHelp": "どの案件かを選ぶと、その案件にこの送り状番号を記入し入庫完了にします。返送伝票番号が空の受付案件のみ表示されます — 番号が誤って記入されている場合は受付画面で直してから箱を再度スキャンしてください。",
  "orphan.searchLabel": "受付案件を探す",
  "orphan.searchPlaceholder": "注文番号 · 受取人",
  "orphan.link": "紐づけ",
  "orphan.linked": "{orderNo} に紐づけて入庫処理しました",
  "orphan.noCandidates": "紐づけられる受付案件がありません。",
  "orphan.noCandidatesHint": "返送伝票番号が空の受付案件のみ紐づけられます。まだ受付されていない場合は、荷主の受付後に紐づけてください。",
  "scan.orphanAll": "未登録貨物の一覧",
  "orphans.title": "未登録貨物",
  "orphans.description": "受付がないまま倉庫に届いた荷物です。入庫スキャン画面と同じ一覧で、紐づけも同じです。",
  "orphans.count": "全{count}件",
  "orphans.search": "検索",
  "orphans.searchPlaceholder": "送り状番号 · 注文番号 · 受取人",
  "orphans.trackingNo": "送り状番号",
  "orphans.linkState": "紐づけ",
  "orphans.open": "未紐づけ",
  "orphans.resolved": "紐づけ済み",
  "orphans.carrierUnknown": "不明",
  "orphans.lastSeenAt": "スキャン日時",
  "orphans.firstSeenAt": "初回入荷",
  "orphans.firstSeenBy": "スキャンした人",
  "orphans.resolvedCase": "紐づけた受付案件",
  "orphans.caseStatus": "入庫状態",
  "orphans.resolvedAt": "紐づけ日時",
  "orphans.action": "操作",
  "orphans.empty": "未登録貨物はありません。",
  "orphans.emptyHint": "受付のない荷物をスキャンするとここに溜まります。通常の入庫貨物はここには表示されません。",
  "scan.todayEmpty": "まだスキャンした件はありません。",
  "scan.freight": "着払い/元払い",
  "scan.count": "本日 {count}件",
  "scan.description": "バーコードを読み取ると入庫処理し、そのまま重量・着払い/元払いの入力に進みます。",
  "scan.app.download": "スキャナーアプリをダウンロード ({size})",
  "scan.app.downloadNote": "ダウンロードしたファイルを開いてインストールします。「提供元不明のアプリ」の許可を求められたら許可してください。インストール後この画面に戻ってもう一度押すとアプリが開きます。",
  "scan.app.downloadDebug": "現在公開されているのは開発用ビルドのためファイルが大きめです。",
  "devices.pairPageTitle": "このアドレスはスキャナーアプリが読み取るものです",
  "devices.pairPageHint": "cooltrack スキャナーアプリのカメラで QR を映してください。",
  "devices.pairPageBody": "通常の QR アプリやブラウザでは登録できません。設定 → スキャナー端末で QR を再表示し、アプリを開いて映してください。",
  "devices.pairPageBack": "スキャナー端末へ",
  "devices.title": "スキャナー端末",
  "devices.description": "倉庫の端末にスキャナーアプリを入れ、ここで作る QR を一度読み取らせると、アプリから直接入庫登録できます。",
  "devices.name": "端末名",
  "devices.namePlaceholder": "例: 倉庫端末 1",
  "devices.add": "端末を登録",
  "devices.newTitle": "アプリでこの QR を読み取ってください",
  "devices.newHint": "アプリを開くとカメラが起動します。下の QR を映すと登録が完了します。",
  "devices.onceOnly": "この QR は今だけ表示されます。閉じると再表示できないため、読み取れなかった場合は端末を登録し直してください。",
  "devices.qrAlt": "端末登録用 QR コード",
  "devices.empty": "登録された端末はありません。",
  "devices.lastUsed": "最終使用",
  "devices.revoke": "解除",
  "devices.revoked": "解除済み",
  "scan.camera.open": "カメラでスキャン",
  "scan.camera.manualLabel": "または送り状番号を直接入力",
  "scan.camera.starting": "カメラを起動しています…",
  "scan.camera.aim": "バーコードを枠の中に合わせてください",
  "scan.camera.processing": "{code} を処理中…",
  "scan.camera.next": "{code} を読み取りました・次のバーコードを映してください",
  "scan.camera.paused": "入力中のためスキャンを止めています",
  "scan.camera.rescan": "再スキャン",
  "scan.camera.torch": "ライト",
  "scan.camera.close": "カメラを閉じる",
  "scan.camera.resume": "カメラを再開",
  "scan.camera.retry": "もう一度試す",
  "scan.camera.stoppedIdle": "しばらく使われなかったためカメラを止めました。",
  "scan.camera.stoppedHidden": "画面から離れたためカメラを止めました。",
  "scan.camera.focusHere": "タップした場所にピントを合わせ直す",
  "scan.camera.slowHint": "バーコード全体を枠に収め、手ぶれしないように持ってください。ぼやける場合は画面のバーコードをタップするとその場所にピントを合わせ直します。暗い場合はライトを点けるか番号を直接入力してください。",
  "scan.camera.slowHintNoFocus": "この端末はピントを調整できません。バーコードが画面の横幅の半分以上になるよう距離を合わせ、それでもぼやける場合は少し離してください。暗い場合はライトを点け、読めないときは番号を直接入力してください。",
  "scan.camera.manualFallback": "下の入力欄に送り状番号を直接入力しても入庫処理できます。",
  "scan.camera.error.permission": "カメラの使用が拒否されました。ブラウザの設定でカメラを許可してください。",
  "scan.camera.error.notFound": "使えるカメラがありません。",
  "scan.camera.error.inUse": "ほかのアプリがカメラを使用中のため起動できませんでした。",
  "scan.camera.error.insecure": "カメラは安全な接続（https）でのみ使えます。",
  "scan.camera.error.unsupported": "このブラウザはカメラスキャンに対応していません。",
  "scan.camera.error.engine": "バーコード読み取り機能を読み込めませんでした。ネットワークを確認してください。",
  "scan.camera.error.unknown": "カメラを起動できませんでした。",

  "shipments.title": "船積み",
  "shipments.new": "選んだ件で船積みを作成",
  "shipments.no": "船積み番号",
  "shipments.caseCount": "件数",
  "shipments.totalWeight": "総重量",
  "shipments.boxCount": "箱数",
  "shipments.shippedOn": "出庫日",
  "shipments.seinoNo": "西濃番号",
  "shipments.osakaArrivedOn": "大阪着",
  "shipments.vesselOn": "配船日",
  "shipments.panstarTracking": "パンスター追跡番号",
  "shipments.invoice": "インボイスをダウンロード",
  "shipments.ship": "出庫処理",
  "shipments.osaka": "大阪着を記録",
  "shipments.departJp": "日本出航を記録",
  "shipments.departJpHint": "パンスター追跡番号を記入すると、韓国到着待ちになります。",
  "shipments.arriveKr": "韓国入庫を記録",
  "shipments.arriveKrHint": "韓国の指定倉庫に入った日を記入すると、含まれる返品がすべて完了になります。",
  "shipments.arriveKrWaiting": "韓国到着待ちです。入庫確認は韓国側が行います。",
  "shipments.krArrivedOn": "韓国入庫日",
  "shipments.empty": "船積みはありません。",
  "shipments.readyTitle": "出庫待ちの返品",
  "shipments.readyEmpty": "出庫できる件はありません。",
  "shipments.cases": "含まれる返品",
  "shipments.selected": "{count}件選択",
  "shipments.summary": "船積み情報",
  "shipments.step.draft": "準備",
  "shipments.step.shipped": "出庫",
  "shipments.step.osaka_arrived": "大阪到着",
  "shipments.step.sailed": "海上輸送",
  "shipments.step.delivered": "返送完了",

  "itemMasters.title": "品目マスタ",
  "itemMasters.code": "コード",
  "itemMasters.nameKo": "品名(韓国語)",
  "itemMasters.nameEn": "品名(英語)",
  "itemMasters.hsCode": "HSコード",
  "itemMasters.origin": "原産地",
  "itemMasters.originHint": "選んだ値がインボイスにそのまま記載されます。",
  "origin.KOREA": "韓国(KOREA)",
  "origin.CHINA": "中国(CHINA)",
  "origin.JAPAN": "日本(JAPAN)",
  "itemMasters.price": "既定単価",
  "itemMasters.active": "使用",
  "itemMasters.add": "品目を追加",
  "itemMasters.edit": "編集",
  "itemMasters.editTitle": "品目の編集",
  "itemMasters.codeLocked": "コードは品目を指す名前のため変更しません。",
  "itemMasters.empty": "登録された品目はありません。",
  "itemMasters.org": "荷主",
  "itemMasters.common": "共通",
  "itemMasters.inactive": "未使用",
  "itemMasters.searchTitle": "登録品目",

  "settings.title": "アカウント",
  "settings.account": "アカウント情報",
  "settings.language": "表示言語",
  "settings.languageKo": "韓国語",
  "settings.languageJa": "日本語",
  "settings.name": "氏名",
  "settings.id": "ログインID",
  "settings.role": "役割",

  "settings.password": "パスワード",
  "settings.passwordDesc": "定期的に変更するとアカウントがより安全になります。",
  "settings.passwordAction": "パスワード変更",

  "password.title": "パスワード変更",
  "password.description": "現在のパスワードを確認してから新しいパスワードに変更します。",
  "password.formTitle": "パスワードの入力",
  "password.current": "現在のパスワード",
  "password.new": "新しいパスワード",
  "password.confirm": "新しいパスワード（確認）",
  "password.hint": "{min}文字以上で入力してください。",
  "password.submit": "パスワードを変更",
  "password.submitting": "変更中…",
  "password.doneTitle": "パスワードを変更しました。",
  "password.doneBody": "安全のためすべての端末からログアウトしました。新しいパスワードで再度ログインしてください。",
  "password.doneLogin": "再ログイン",

  "common.loading": "読み込み中…",
  "common.save": "保存",
  "common.cancel": "キャンセル",
  "common.close": "閉じる",
  "common.confirm": "確認",
  "common.yes": "はい",
  "common.no": "いいえ",
  "common.none": "—",
  "common.required": "必須",
  "common.select": "選択",
  "common.retry": "再試行",
  "common.saved": "保存しました。",
  "common.edit": "編集",
  "common.done": "完了",
  "common.menu": "メニュー",
  "common.remove": "消す",
  "common.back": "戻る",
  "login.subtitle": "社内アカウントでログインしてください。",

  "blocker.DISPOSITION_REQUIRED": "先に処理方針を決めてください。",
  "blocker.NO_INVOICE_ITEMS": "先にインボイス品目を記入してください。",
  "blocker.NOT_INSPECTED": "検品がまだ終わっていません。",
  "blocker.REVIEW_PENDING": "項目の確認依頼中です。修正が必要です。",
  "blocker.INVALID_STATUS_TRANSITION": "現在の段階ではできません。",
  "blocker.CASE_NOT_DOCUMENTED": "書類を確定するとインボイスを出力できます。",

  "error.UNAUTHORIZED": "ログインが必要です。",
  "error.FORBIDDEN": "権限がありません。",
  "error.NOT_FOUND": "見つかりません。",
  "error.INTERNAL": "サーバーで問題が起きました。しばらくして再試行してください。",
  "error.VALIDATION_FAILED": "入力内容を確認してください。",
  "error.MALFORMED_JSON": "リクエストの形式が正しくありません。",
  "error.INVALID_CREDENTIALS": "ログインIDまたはパスワードが違います。",
  "error.INVALID_CURRENT_PASSWORD": "現在のパスワードが正しくありません。",
  "error.PASSWORD_TOO_SHORT": "パスワードは10文字以上で入力してください。",
  "error.PASSWORD_TOO_LONG": "パスワードが長すぎます。",
  "error.PASSWORD_CONFIRM_MISMATCH": "新しいパスワードと確認が一致しません。",
  "error.PASSWORD_SAME_AS_CURRENT": "現在のパスワードとは異なるパスワードを入力してください。",
  "error.CASE_NOT_FOUND": "該当する返品が見つかりません。",
  "error.ORG_REQUIRED": "荷主を選んでください。",
  "error.TRACKING_NO_DUPLICATED": "すでに登録されている伝票番号です。",
  "error.TRACKING_NO_NOT_FOUND": "その伝票番号の返品はありません。",
  "error.TRACKING_NO_REQUIRED": "伝票番号を入力してください。",
  "error.TRACKING_NO_MISMATCH": "この件の返送伝票番号と異なります。",
  "error.STALE_UPDATE": "他の人が先に更新しました。最新の内容を読み込みます。",
  "error.INTAKE_LOCKED": "入庫後は受付内容を変更できません。",
  "error.NOTHING_TO_UPDATE": "変更する内容がありません。",
  "error.INVALID_STATUS_TRANSITION": "現在のステータスではできない処理です。",
  "error.ALREADY_ARRIVED": "すでに入庫処理済みです。",
  "error.ORPHAN_NOT_FOUND": "その無敵貨物の記録が見つかりません。",
  "error.ORPHAN_ALREADY_RESOLVED": "すでに別の案件に紐づけられています。一覧を再読み込みします。",
  "error.NOT_ARRIVED_YET": "まだ入庫していません。",
  "error.COD_FEE_ON_PREPAID": "元払いの場合は着払い料金を入力しません。",
  "error.DISPOSITION_REQUIRED": "先に処理方針を決めてください。",
  "error.NO_INVOICE_ITEMS": "インボイス品目がありません。",
  "error.NOT_INSPECTED": "先に検品を終えてください。",
  "error.NO_CASE_LINES": "この件には返品商品が登録されていません。",
  "error.CASE_LINE_NOT_FOUND": "その行が見つかりません。",
  "error.INSPECT_INCOMPLETE": "すべての行の数量を記入すると検品が完了します。",
  "error.LINE_DESCRIPTION_REQUIRED": "商品名を記入するか品目を選んでください。",
  "error.REVIEW_PENDING": "項目の確認依頼中です。",
  "error.DISPOSITION_MISMATCH": "廃棄と決めた件のみ廃棄できます。",
  "error.ITEM_MASTER_NOT_FOUND": "その品目は使用できません。",
  "error.ITEM_DESCRIPTION_REQUIRED": "品名とHSコードが必要です。",
  "error.ITEM_CODE_DUPLICATED": "すでにある品目コードです。",
  "error.MIXED_CURRENCY": "1つのインボイスに複数の通貨は混在できません。",
  "error.INVALID_AMOUNT": "金額の形式が正しくありません。",
  "error.INVALID_QUANTITY": "数量の形式が正しくありません。",
  "error.SHIPMENT_NOT_FOUND": "船積みが見つかりません。",
  "error.NO_CASES_SELECTED": "返品を1件以上選んでください。",
  "error.ALREADY_IN_SHIPMENT": "すでに別の船積みに含まれています。",
  "error.CASE_NOT_DOCUMENTED": "書類が確定していない件があります。",
  "error.INVALID_SHIPMENT_TRANSITION": "現在の船積みステータスではできない処理です。",
  "error.NETWORK": "サーバーに接続できませんでした。",

  "event.intake_created": "受付登録",
  "event.intake_updated": "受付内容の修正",
  "event.cancelled": "受付取消",
  "event.scanned_in": "入庫スキャン",
  "event.arrived_manually": "手入力で入庫",
  "event.orphan_linked": "無敵貨物から紐づけ入庫",
  "event.weight_set": "重量記録",
  "event.freight_set": "着払い/元払い記録",
  "event.inspected": "検品",
  "event.lines_replaced": "返品商品の修正",
  "event.arrival_confirmed": "入庫内容の確認",
  "event.disposition_set": "処理方針の決定",
  "event.items_replaced": "インボイス品目の記入",
  "event.review_requested": "項目の確認依頼",
  "event.doc_confirmed": "書類の確定",
  "event.assigned_shipment": "船積みへの割当",
  "event.shipped": "出庫",
  "event.osaka_arrived": "大阪着",
  "event.departed_jp": "日本出航",
  "event.returned": "返送完了",
  "event.discarded": "廃棄",
}
